// Support action types
export const FETCH_SUPPORT_REQUESTS = 'FETCH_SUPPORT_REQUESTS';
